import { get } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class FilterList<T extends object> {
	@tracked typedFilter = '';

	showSearchLimit: number; // max number of items before search line appears
	items: T[];
	filterProperties: string[];

	constructor(options: { items?: T[]; filterProperties?: string[]; showSearchLimit?: number }) {
		this.showSearchLimit = options.showSearchLimit || 0;
		this.items = options.items || [];
		this.filterProperties = options.filterProperties || [];
	}

	get showSearch(): boolean {
		return this.items.length > this.showSearchLimit;
	}

	get filteredItems(): T[] {
		const typedFilter = this.typedFilter.toLowerCase();

		return this.items.filter((item) => {
			return (
				!typedFilter ||
				this.filterProperties.some((property: string) => {
					const value = get(item, property);
					return typeof value === 'string' && value.toLowerCase().includes(typedFilter);
				})
			);
		});
	}
}
